var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1989 1.64074C12.2214 1.08892 11.7923 0.623322 11.2405 0.600807L2.24796 0.233906C1.69613 0.211391 1.23054 0.640482 1.20802 1.19231C1.18551 1.74413 1.6146 2.20973 2.16642 2.23224L10.1598 2.55838L9.83364 10.5517C9.81112 11.1036 10.2402 11.5691 10.792 11.5917C11.3439 11.6142 11.8095 11.1851 11.832 10.6333L12.1989 1.64074ZM1.67769 11.7353L11.8774 2.33532L10.522 0.86463L0.322308 10.2647L1.67769 11.7353Z",
    fill: "#0e131c"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlack);
export default __webpack_public_path__ + "static/media/arrow-black.59760f9147be113b41b82580d9309cba.svg";
export { ForwardRef as ReactComponent };